const SPLASH_ID = "app-splash";
const HIDE_CLASS = "app-splash--hide";

let splashTransitionStarted = false;

export function transitionFromAppSplash(): void {
  if (splashTransitionStarted || typeof document === "undefined") {
    return;
  }

  const splash = document.getElementById(SPLASH_ID);
  if (!splash) {
    return;
  }

  splashTransitionStarted = true;
  splash.classList.add(HIDE_CLASS);

  const removeSplash = () => {
    splash.remove();
  };

  splash.addEventListener("transitionend", removeSplash, { once: true });
  window.setTimeout(removeSplash, 400);
}
